module.exports = __webpack_public_path__ + "static/media/icon_telegram.b9baed5c.png";